import { render, staticRenderFns } from "./AddSection.vue?vue&type=template&id=3d84f630&"
import script from "./AddSection.vue?vue&type=script&lang=ts&"
export * from "./AddSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports